const wrapTranslations = (inputTranslations = []) => ({
  common: inputTranslations.reduce(
    (translations, translation) => ({
      ...translations,
      [translation.key]: translation.value
    }),
    {}
  )
})

module.exports = wrapTranslations
